import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import MedicationsListBody from "components/PatientManagement/Medications/MedicationsListBody";

export default function Medications() {
  useEffect(() => {
    document.title = "Medications";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <MedicationsListBody />
    </main>
  );
}
